import { Box, TypographyStylesProvider } from "@mantine/core";
import React from "react";
import { IconAlertOctagon } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";

export const ERRORS_CONTENT = (
  <TypographyStylesProvider>
    <p>In this History menu, we can see our node's recent errors:</p>

    <DocsButton
      ariaLabel="Errors button"
      text="Errors"
      leftSection={<IconAlertOctagon />}
    />
    <p>
      Errors are a fact of life on the Lightning Network. Not all payments will
      succeed, and it's not always straightforward to diagnose failures when
      they occur. Here are some common errors you might encounter:
    </p>

    {/* Error 1: Insufficient Balance */}
    <Box mb="20px">
      <JsonView
        data={{
          stamp: 1730155678273,
          error_data: {
            id: "7229a175e29e5125b80ca77c74dbc91eb66523db39d5d353d11d32a4905f9aee",
            is_canceled: false,
            is_invalid_payment: false,
            is_route_not_found: false,
            is_pathfinding_timeout: false,
            is_insufficient_balance: true,
          },
          description: "Insufficient balance",
        }}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>
    <p>
      <b>Error Type:</b> <i>Insufficient Balance</i>
    </p>
    <p>
      This error occurs when, somewhere along the route your node is using to
      send a payment, one of the channels had too small a balance on one side of
      the channel. Channel balances on the Lightning Network are both private
      and highly dynamic, so this error can often be challenging to debug.
    </p>

    {/* Error 2: Route Not Found */}
    <Box mb="20px">
      <JsonView
        data={{
          stamp: 1730155123088,
          error_data: {
            id: "a6f9a6ab376afd4a7935f56cfb55dd822931a6d94d516c737a4b91691404bbe7",
            is_canceled: false,
            is_invalid_payment: false,
            is_route_not_found: true,
            is_pathfinding_timeout: false,
            is_insufficient_balance: false,
          },
          description: "Route not found",
        }}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>
    <p>
      <b>Error Type:</b> <i>Route Not Found</i>
    </p>
    <p>
      This error indicates that your node could not find a suitable route to the
      destination. Possible reasons include low liquidity or no path was found
      through network. These errors can be very tricky to debug, since although
      the existence of channels is known publicly on the network, the "available
      balance" on each side of each channels not public.
    </p>

    {/* Error 3: Temporary Channel Failure */}
    <Box mb="20px">
      <JsonView
        data={{
          stamp: 1730155001354,
          error_data: {
            index: 1,
            route: {
              fee: 1,
              hops: [
                {
                  fee: 1,
                  channel: "16000000x0x3",
                  forward: 1,
                  timeout: 3195961,
                  public_key:
                    "03a951e02ab549c2ec60d35b5c3bae842fdae176a68e0cfdc2a479063f2b0aa270",
                  fee_mtokens: "1001",
                  forward_mtokens: "1000",
                  channel_capacity: 500000,
                },
                {
                  fee: 0,
                  channel: "16000000x0x4",
                  forward: 1,
                  timeout: 3195961,
                  public_key:
                    "0309ddf2e08b706e0cb1f1c7503d36cef9d895d835bfb0c3840315dc3808194323",
                  fee_mtokens: "0",
                  forward_mtokens: "1000",
                  channel_capacity: 1,
                },
              ],
              tokens: 2,
              mtokens: "2001",
              payment:
                "210178b2d310531378b0966591ccef80667a98ac5b64b67c17837dbba7e9a64e",
              timeout: 3196041,
              fee_mtokens: "1001",
              total_mtokens: "1000",
            },
            reason: "TemporaryChannelFailure",
            channel: "16000000x0x4",
            mtokens: "2001",
            public_key:
              "03a951e02ab549c2ec60d35b5c3bae842fdae176a68e0cfdc2a479063f2b0aa270",
          },
          description: "Temporary Channel Failure",
        }}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>
    <p>
      <b>Error Type:</b> <i>Temporary Channel Failure</i>
    </p>
    <p>
      This error means that one of the channels in the payment route failed. In
      this case, the error occurred in channel <code>"16000000x0x4"</code>.
    </p>

    {/* Error 4: Error Connecting to Peer */}
    <Box mb="20px">
      <JsonView
        data={{
          stamp: 1730137971186,
          error_data: [503, "FailedToSuccessfullyConnectToRemotePeer"],
          description: "Error connecting to peer",
        }}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>
    <p>
      <b>Error Type:</b> <i>Error Connecting to Peer</i>
    </p>
    <p>
      This error occurs when your node fails to connect to a remote peer.
      Usually this is because the node you are trying to connect with has gone
      offline.
    </p>
  </TypographyStylesProvider>
);
